/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor, dlsDarkColor} from '../../theme/theme';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Filter Favorite Working Icon component.
 */
export const FilterFavoriteWorkingIcon = (props: IconProps) => {
  const {iconSize, isDark} = useIconDLS(props);
  const stroke             = dlsDarkColor(isDark, 'grey1', '#333333');
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M7.72656 5.3252C9.02151 5.32559 10.2343 6.21694 10.9229 6.87012L11.4805 7.39941L11.8242 7.72559L12.168 7.39941L12.7256 6.87012C13.4142 6.21695 14.6269 5.32561 15.9219 5.3252C17.7567 5.3252 19.3242 6.92268 19.3242 8.97559C19.3241 9.46507 19.1009 10.03 18.7754 10.5586C18.6219 10.8079 18.4649 11.0154 18.3457 11.1631L18.1328 11.4092L11.8232 18.0967L5.50195 11.3965L5.2998 11.1611C5.18105 11.0139 5.02506 10.8062 4.87207 10.5576C4.54723 10.0297 4.32438 9.46519 4.32422 8.97559L4.3291 8.78418C4.41967 6.88738 5.85143 5.42276 7.55469 5.33008L7.72656 5.3252Z' fill='#DA3737' stroke={dlsColor('white')} />
      <path d='M23.1399 12.3671L17.3703 22.3777L15.4464 23C15.4417 22.9992 15.437 22.9974 15.4328 22.995C15.4283 22.9923 15.4245 22.9888 15.4214 22.9847L15 21.0179L20.7687 11L23.1399 12.3671Z' stroke={stroke} strokeWidth='1.125' strokeMiterlimit='10' />
      <path d='M19.2935 13.0596L22.0364 14.6432' stroke={stroke} strokeWidth='1.125' strokeMiterlimit='10' />
    </svg>
  );
};

export default FilterFavoriteWorkingIcon;
